import { ActionType, createAction } from "typesafe-actions";

import TrafficLayerData from "./TrafficLayerData";

export const setTrafficSettings = createAction("map/traffic/setTrafficSettings")<
  TrafficLayerData | undefined
>();

export type TrafficActions = ActionType<typeof setTrafficSettings>;
